import React from 'react';
import defaultLogo from '../../assets/images/PT_Text.png';
import { useStrings } from '../../i18n';

export default function NavbarLogo({
  onClick,
  src,
  alt,
  sizeClass = 'h-10 md:h-12 lg:h-14'
}) {
  const logoSrc = src || defaultLogo;
  const strings = useStrings();
  const altText = alt || strings.nav.logoAlt;

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-3 cursor-pointer bg-transparent border-0 p-0 hover:opacity-80 transition"
      aria-label="Go to top / home"
    >
      <img
        src={logoSrc}
        alt={altText}
        className={`${sizeClass} object-contain`}
      />
    </button>
  );
}
